export default "__VITE_ASSET__DLjsc8En__"